import { render, staticRenderFns } from "./shestirenkaLoader.vue?vue&type=template&id=f1ab98f0&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1ab98f0')) {
      api.createRecord('f1ab98f0', component.options)
    } else {
      api.reload('f1ab98f0', component.options)
    }
    module.hot.accept("./shestirenkaLoader.vue?vue&type=template&id=f1ab98f0&", function () {
      api.rerender('f1ab98f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/shestirenkaLoader.vue"
export default component.exports